import React from 'react'
import Show from 'services/Show';
import { formatDate } from 'services/utils';
import { showClasses, dogSexes } from 'services/constants';
import './show_diploma.sass';
import { Spinner } from 'components/atoms';
import PrinterSelect from 'components/PrinterSelect';
import PrintButton from 'components/PrintButton';

export default class ShowDiplomas extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      show: {},
      dogs: [],
      catNum: {
        min: 1,
        max: 1,
      },
      catNumToShow: {
        min: 1,
        max: 1,
      },
      maxNumber: 1,
      showId: match.params.id,
    }
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.loadData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadData = () => {
    this.setState({loading: true});
    Show.getDiplomas(this.state.showId).then(({show, dogs}) => {
      if (this.mounted) {
        const maxNumber = dogs[dogs.length-1].catalog_number;
        this.setState({ show: new Show(show), dogs, maxNumber });
      }
    }).catch(alert).then(() => {
      if (this.mounted) {
        this.setState({loading: false});
      }
    });
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  catNumChanged = ({target}) => {
    let catNum = this.state.catNum;
    let value = target.value * 1;
    // if (value <= 0) value = 1;
    catNum[target.name] = value;
    this.setState({ catNum });
  }

  checkCatNums = () => {
    let catNum = this.state.catNum;
    let updateState = false;
    if (catNum.min > catNum.max) {
      catNum.max = catNum.min;
      updateState = true;
    } else if (catNum.max - catNum.min > 100) {
      catNum.max = catNum.min + 100;
      updateState = true;
    }
    if (catNum.max > this.state.maxNumber) {
      updateState = true;
      catNum.max = this.state.maxNumber;
      if (catNum.min > catNum.max) {
        catNum.min = catNum.max;
      }
    }
    if (updateState) this.setState({ catNum });
  }

  apply = () => {
    this.checkCatNums();
    let catNumToShow = this.state.catNum;
    this.setState({ catNumToShow });
  }

  renderDiplomas() {
    const {catNumToShow, dogs, show} = this.state;
    if (!dogs) return null;
    let diplomas = [];
    dogs.forEach(dog => {
      if (dog.catalog_number >= catNumToShow.min && dog.catalog_number <= catNumToShow.max) {
        diplomas.push(<Diploma key={dog.id} dog={dog} show={show} />)
      }
    });
    return diplomas;
  }

  render() {
    const {catNum, show, loading} = this.state;
    let showInfo = null;
    if (show) {
      showInfo = (
        <span className="show">
          <span className="show-date"> {formatDate(show.starts_at)} </span>
          <i> / </i>
          <strong className="show-name"> {show.name} </strong>
        </span>
      )
    }

    if (!show || loading) {
      return (
        <div className="container-fluid">
          <h4>Дипломы собак выставки - {showInfo}</h4>
          {loading && <Spinner /> }
        </div>
      )
    }
    const diplomas = this.renderDiplomas()

    return (
      <div className="container-fluid">
        <div className="no-print">
          <h4>Дипломы собак выставки - {showInfo}</h4>

          <h5>Для собак</h5>
          <div className="row">
            <div className="col-md-6">
              <label>Номер по каталогу</label>
              <div className="row">
                <div className="col-2">
                  <label>от</label>
                  <input id="catNum_min" type="number" name="min" className="form-control" 
                    value={catNum.min} onChange={this.catNumChanged} onBlur={this.apply} />
                </div>
                <div className="col-2">
                  <label>до</label>
                  <input id="catNum_max" type="number" name="max" className="form-control" 
                    value={catNum.max} onChange={this.catNumChanged} onBlur={this.apply} />
                </div>
                <div className="col-4">
                  <label>Принтер</label>
                  <PrinterSelect className="form-select" orientation="portrait" />
                </div>
                <div className="col-2">
                  <label className="row">&nbsp;</label>
                  <PrintButton disabled={!diplomas} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="diplomas">
          {diplomas}
        </div>
      
      </div>
    );
  }
}

function Diploma({show, dog}) {
  const classNum = parseInt(dog.class_in_show);
  const classInShow = classNum ? showClasses.find(classObj => classObj.id === classNum) : null;
  const className = classInShow ? classInShow.name : '---';
  const dogSex = dogSexes[dog.sex] || dog.sex;
  return (
    <div id={`diploma-${dog.id}`} className="diploma print-page">
      <div className="dog-number">№ {dog.catalog_number}</div>
      <div className="dog-breed">{dog.breed_num ? `FCI ${dog.breed_num} - ` : ''}{dog.breed_name} / {dog.breed_name_lat}</div>
      <div className="dog-name">{dog.name}</div>
      <div className="dog-class">{className}</div>
      <div className="dog-sex">{dogSex}</div>
      <div className="dog-owner">{dog.owner_name}</div>
      <div className="dog-expert">{dog.expert_name} ({dog.expert_country_name})</div>
      <div className="show-date">{formatDate(show.starts_at, 'yyyy.MM.dd')}</div>
    </div>
  );
}